import { requestHandler } from "../lib/utils/network-client";

export function getGovApprovals(params = {}) {
  return requestHandler("/gov-approvals", {
    params
  });
}

export function createGovApproval(payload) {
  return requestHandler("/gov-approvals", {
    method: "POST",
    body: payload
  });
}

export function updateGovApproval(id, payload) {
  return requestHandler(`/gov-approvals/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteGovApproval(id) {
  return requestHandler(`/gov-approvals/${id}`, {
    method: "DELETE"
  });
}
